/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Lifecycle_Delete_Purge_IntroInputs */

const en_lifecycle_delete_purge_intro = /** @type {(inputs: Lifecycle_Delete_Purge_IntroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} still contains work. Deleting it permanently removes everything listed below, including relations and attachments. This cannot be undone.`)
};

const de_lifecycle_delete_purge_intro = /** @type {(inputs: Lifecycle_Delete_Purge_IntroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} enthält noch Arbeit. Beim Löschen wird alles unten Aufgeführte dauerhaft entfernt, auch Beziehungen und Anhänge. Das lässt sich nicht rückgängig machen.`)
};

/**
* | output |
* | --- |
* | "{name} still contains work. Deleting it permanently removes everything listed below, including relations and attachments. This cannot be undone." |
*
* @param {Lifecycle_Delete_Purge_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_delete_purge_intro = /** @type {((inputs: Lifecycle_Delete_Purge_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Delete_Purge_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_delete_purge_intro(inputs)
	return en_lifecycle_delete_purge_intro(inputs)
});